export default {
      path: '/lvy-logout-prompt-v2',
      component: () => import('./LVYLogoutPromptV2'),
      meta: {
        title: '注销须知',
        designWidth:750,
        expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (GMT+08:00)',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      }
    }
